module.exports = __webpack_public_path__ + "985ad3040e8bf73dff50f01dee589fe5.png";